import { Component, OnInit, Input } from '@angular/core';
import { OutletOrderTimingManager, IExpressOrderingOutlet, IOutlet } from '@cakeiteasy/web-utils';

@Component({
  standalone: true,
  selector: 'ui-earliest-pick-up',
  template: '<div class="earliest-pick-up" [innerHTML]="timeText"></div>',
  styleUrls: ['./ui-earliest-pick-up.component.scss']
})
export class UiEarliestPickUpComponent implements OnInit {
  @Input() outlet: IOutlet | IExpressOrderingOutlet;
  public timeText: string;

  constructor(private _outletOrderTiming: OutletOrderTimingManager) {
  }

  ngOnInit() {
    if ('orderTiming' in this.outlet && this.outlet.orderTiming) {
      this.timeText = this._outletOrderTiming.getOutletEarliestTimeText(this.outlet as IExpressOrderingOutlet);
    }
  }

}
